<template>
  <v-container>
      <v-row>
          <v-col :lg="6" class="p-4" v-if="success===true">


              <p>Vaša objednávka bola zrušená.</p>
              <v-btn link :to="{name: 'home'}">Nová rezervácia</v-btn>
      </v-col>
          <v-col :lg="6" class="p-4" v-if="error===true">


              <p class="red--text">Pri rušení Vašej rezervácie nastala chyba, kontaktujte nás prosím.</p>
              <v-btn link :to="{name: 'home'}">Nová rezervácia</v-btn>
      </v-col>
      </v-row>


  </v-container>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Home',
  data: () => ({
    success: false,
    error: false,
  }),
  mounted() {
    const that = this;
    Vue.axios.delete(`public/orders/${this.$route.params.id}`)
      .then((response) => {
        if (response.data && response.data.data && response.data.data.result === 'success') {
          that.success = true;
        }
        // item.defaultValue = response.data.data;
      })
      .catch((error) => {
        that.error = true;
      });
  },
};
</script>
